import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export function MetricCard({
  label,
  value,
  suffix,
  icon: Icon,
  accent = 'blue',
  hint,
}: {
  label: string;
  value: string | number;
  suffix?: string;
  icon: LucideIcon;
  accent?: 'blue' | 'indigo' | 'cyan' | 'teal';
  hint?: string;
}) {
  const accents = {
    blue: 'text-accent-blue bg-accent-blue/10',
    indigo: 'text-accent-indigo bg-accent-indigo/10',
    cyan: 'text-accent-cyan bg-accent-cyan/10',
    teal: 'text-accent-teal bg-accent-teal/10',
  };
  return (
    <div className="panel p-5">
      <div className="mb-3 flex items-center gap-2.5">
        <span className={cn('flex h-8 w-8 items-center justify-center rounded-lg', accents[accent])}>
          <Icon size={16} />
        </span>
        <span className="text-sm font-medium text-text-secondary">{label}</span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-bold tracking-tight text-text-primary">{value}</span>
        {suffix && <span className="text-sm text-text-muted">{suffix}</span>}
      </div>
      {hint && <p className="mt-1.5 text-xs text-text-muted">{hint}</p>}
    </div>
  );
}
